import { FilterInputValue } from "@/types/common";

export const countActiveFilters = (
    filters: Record<string, FilterInputValue>,
) => {
    return Object.values(filters).reduce(
        (sum: number, vals) => sum + (Array.isArray(vals) ? vals.length : 0),
        0,
    );
};
